'use client';

import api from '@lib/api';
import axios from 'axios';
import { useEffect, useState } from 'react';
export const useFinchData = (filters, programTypes) => {
  const STARTED_PARAMS = {
    isCalculator: 1,
    objectTypes: '1,2',
    // подставляем id последнего нового корпуса
    bulkId: 10100,
    project: 'forma',
    locations: '2,3'
  };
  const [programs, setPrograms] = useState([]);
  const [ranges, setRanges] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      setIsError(null);
      try {
        const optionalType = programTypes.find(t => t.active)?.value;
        const response = await axios.get(api.pikFinchMortgage, {
          params: {
            ...STARTED_PARAMS,
            ...filters,
            ...(optionalType !== null && {
              optionalType
            })
          }
        });
        if (!cancelled) {
          const data = response.data.data;
          setPrograms(data?.programs ?? []);
          setRanges(data?.ranges ?? {});
        }
      } catch (e) {
        if (!cancelled) setIsError(e);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [filters, programTypes]);
  return {
    programs,
    ranges,
    isLoading,
    isError
  };
};